import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Grid,
  Button,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  CardContent,
  CardMedia,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningIcon from "@mui/icons-material/Warning";
import { useDispatch, useSelector } from "react-redux";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import {
  setSelectedLocations,
  setSelectedMeetingRooms,
} from "../../redux/slices/scheduleSectionSlice";
import axios from "axios";
import { setMeeting } from "../../redux/slices/meetingSlice";
import { setMeetingSpaces } from "../../redux/slices/allMeetingSpacesSlice";
import ConfirmationDialog from "../ConfirmationDialog";
import { layoutSlice } from "../../redux/slices/layoutSlice";

const MyLocationsSmallCard = ({
  locations,
  actions,
  conflictingRooms,
  setConflictingRooms,
  isConflict = false
}) => {
  const dispatch = useDispatch();
  const [rows, setRows] = React.useState([]);
  const [showImage, setShowImage] = useState(false);
  const [content, setContent] = useState(null);
  const api = localStorage.getItem("api");
  const meetingData = useSelector((state) => state?.meeting?.meeting);

  const { locationIds, roomIds } = useSelector((state) => state?.schedule);
  const meetingSpaces = useSelector(
    (state) => state?.allmeetingspaces?.allmeetingspaces
  );
  const eventCustomisations = useSelector(
    (state) => state?.eventcustomisations?.eventcustomisations
  );
  const headers = useSelector((state) => state?.header);
  const emmsheaders = useSelector((state) => state?.emmsheader);
  const curremms = useSelector((state) => state.curremms);
  const [selectedOption, setSelectedOption] = useState(curremms?.curremms?.id);
  const [locationsToRender, setLocationsToRender] = useState([]);
  const playlists = useSelector((state) => state.playlist.playlist);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );
  const [matchedEntry, setMatchedEntry] = useState();
  const layouts = useSelector((state) => state.layout.layout);
  const user = useSelector((state) => state?.user?.user);
  const groupIds = user?.customProperties?.belongsTo;
  useEffect(() => {
    if (actions) {
      const filteredLocations = locations.filter((location) =>
        locationIds.includes(location.id)
      );
      setLocationsToRender(filteredLocations);
    } else {
      setLocationsToRender(locations);
    }
  }, [actions, locationIds, locations]);

  const hasConflicts = (roomId) => {
    return conflictingRooms?.some((room) => room?.roomId === roomId);
  };

  useEffect(() => {
    const meetingObject = JSON.parse(localStorage.getItem("meetingObject"));
    dispatch(setSelectedLocations(meetingObject.locationIds || []));
    dispatch(setSelectedMeetingRooms(meetingObject.roomIds || []));
  }, [dispatch]);

  const handleLocationCheckboxChange = (locationId) => {
    const updatedLocations = locationIds.includes(locationId)
      ? locationIds.filter((id) => id !== locationId)
      : [...locationIds, locationId];


    const meetingRoomsForLocation = meetingSpaces
      .filter((space) => space.locationId === locationId)
      .filter((space) => groupIds?.includes(space?.customProperties?.groups))
      .map((space) => space.id);


    dispatch(setSelectedLocations(updatedLocations));

    const updatedRooms = updatedLocations.includes(locationId)
      ? [...new Set([...roomIds, ...meetingRoomsForLocation])]
      : roomIds.filter((roomId) => !meetingRoomsForLocation.includes(roomId));

    dispatch(setSelectedMeetingRooms(updatedRooms));
    const meetingObject =
      JSON.parse(localStorage.getItem("meetingObject")) || {};
    const updatedMeetingObject = {
      ...meetingObject,
      roomIds: updatedRooms,
      locationIds: updatedLocations,
    };
    localStorage.setItem("meetingObject", JSON.stringify(updatedMeetingObject));
  };

  const handleMeetingRoomCheckboxChange = (roomId) => {
    const updatedRooms = roomIds.includes(roomId)
      ? roomIds.filter((id) => id !== roomId)
      : [...roomIds, roomId];

    const room = meetingSpaces.find((space) => space.id === roomId);
    if (!room) return;

    const roomLocationId = room.locationId;
    let updatedLocations = [...locationIds];

    if (!locationIds.includes(roomLocationId)) {
      updatedLocations.push(roomLocationId);
    } else {
   
      const remainingRoomsInLocation = meetingSpaces
        .filter((space) => space.locationId === roomLocationId)
        .map((space) => space.id)
        .filter((id) => updatedRooms.includes(id));

      if (remainingRoomsInLocation.length === 0) {
        updatedLocations = updatedLocations.filter(
          (id) => id !== roomLocationId
        );
      }
    }

 
    const meetingObject =
      JSON.parse(localStorage.getItem("meetingObject")) || {};
    const updatedMeetingObject = {
      ...meetingObject,
      roomIds: updatedRooms,
      locationIds: updatedLocations,
    };
    localStorage.setItem("meetingObject", JSON.stringify(updatedMeetingObject));

  
    dispatch(setSelectedMeetingRooms(updatedRooms));
    dispatch(setSelectedLocations(updatedLocations));
  };

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [roomToDelete, setRoomToDelete] = useState(null);

  const handleDeleteRoom = (roomId) => {
    setRoomToDelete(roomId);
    setOpenDeleteDialog(true);
  };

  const confirmDeleteRoom = () => {
    const roomId = roomToDelete;
    setOpenDeleteDialog(false);

    const ongoingMeetingIds =
      conflictingRooms
        .find((room) => room.roomId === roomId)
        ?.conflictingMeetings.map((meeting) => meeting.id) || [];

    if (!ongoingMeetingIds.length) {
      return;
    }

    const updatedConflictingRooms = conflictingRooms.map((room) =>
      room.roomId === roomId
        ? {
          ...room,
          conflictingMeetings: room.conflictingMeetings.filter(
            (meeting) => !ongoingMeetingIds.includes(meeting.id)
          ),
        }
        : room
    );

    const roomHasConflicts = updatedConflictingRooms.find(
      (room) => room.roomId === roomId && room.conflictingMeetings.length > 0
    );

    if (!roomHasConflicts) {
      setConflictingRooms(
        updatedConflictingRooms.filter((room) => room.roomId !== roomId)
      );
    } else {
      setConflictingRooms(updatedConflictingRooms);
    }

    ongoingMeetingIds.forEach((meetingId) => {
      const requestBody = {
        path: "meeting",
        query: { meetingId: `${meetingId}` },
        emmsId: selectedOption,
        requestType: "DELETE",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setRows((prevRows) => {
            const updatedRows = meetingData?.filter(
              (row) => row.id !== meetingId
            );
            dispatch(setMeeting(updatedRows));
            return updatedRows;
          });
        })
        .catch((error) => {
          console.error(`Error deleting meeting with ID: ${meetingId}:`, error);
        });
    });
  };

  const handleSkipRoom = (roomId) => {
    const updatedRooms = roomIds.filter((id) => id !== roomId);

    dispatch(setSelectedMeetingRooms(updatedRooms));

    const meetingObject =
      JSON.parse(localStorage.getItem("meetingObject")) || {};
    const updatedMeetingObject = {
      ...meetingObject,
      roomIds: updatedRooms,
      locationIds,
    };
    localStorage.setItem("meetingObject", JSON.stringify(updatedMeetingObject));
  };

  const handleContentRoom = (roomId) => {
    const conflictingRoom = conflictingRooms.find(
      (room) => room.roomId === roomId
    );

    if (!conflictingRoom || !conflictingRoom.conflictingMeetings.length) {
      return;
    }

    const firstConflictingMeeting = conflictingRoom?.conflictingMeetings[0];

    const matchingMeetingObject = meetingData.find(
      (meeting) => meeting.id === firstConflictingMeeting.id
    );

    const layoutId = matchingMeetingObject?.customProperties?.layoutId;
    const layout = layouts.find((layout) => layout.id === layoutId);

    if (!layout) {
      setContent(null);
      setShowImage(true);
      return;
    }

  
    const associatedPlaylist = playlists.find(
      (playlist) => playlist.id === layout.playlistId
    );

    if (!associatedPlaylist || !associatedPlaylist.items?.length) {
      setContent(null);
      setShowImage(true);
      return;
    }

    const firstPlaylistItem = associatedPlaylist.items[0]; 

    const matchedEntry = dataToDisplay.find(
      (entry) => entry.id === firstPlaylistItem?.content_ref
    );

    setShowImage(true);
    setContent(matchedEntry); 
    setMatchedEntry(matchedEntry);
  };

  return (
    <Box
      sx={{
        flex: 1,
        padding: { xs: 0, md: 2 },
        height: { xs: isConflict ? "100%" : "20vh", md: "30vh" },
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "10px",
          border: "2px solid transparent",
          backgroundClip: "padding-box",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
      }}
    >
      {actions && conflictingRooms?.length > 0 ? (
        <Box
          sx={{
            backgroundColor: "#FFFFCC",
            padding: 2,
            height: "10vh",
            borderRadius: "4px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningIcon
            sx={{ color: "orange", marginRight: 1, fontSize: "24px" }}
          />
          <Typography
            variant="h6"
            sx={(theme) => ({
              fontuseight: "bold",
              color: "#333",
              fontSize: "0.7rem",
              [theme.breakpoints.up("md")]: {
                fontSize: theme.typography.h6.fontSize,
              },
            })}
          >
            This Schedule can't be created. Few Meeting Rooms have conflicting
            events.
          </Typography>
        </Box>
      ) : null}

      {actions && conflictingRooms?.length === 0 ? (
        <Box
          sx={{
            backgroundColor: "#e6ffe6",
            padding: 2,
            height: "10vh",
            borderRadius: "4px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DoneAllIcon
              sx={{
                color: "green",
                marginRight: 1,
                fontSize: "24px",
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#333",
              }}
            >
              We are good to go!
            </Typography>
          </Box>
        </Box>
      ) : null}
      <Dialog
        open={showImage}
        onClose={() => setShowImage(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Event Customization Image</DialogTitle>
        <Box sx={{ width: "100%", flexGrow: 1 }}>
          {content && matchedEntry ? (
            <Box>
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
             
                {matchedEntry?.customProperties?.html && (
                  <iframe
                    title="template-content"
                    srcDoc={matchedEntry?.customProperties?.html}
                    style={{
                      width: "100%",
                      height: "150px",
                      border: "none",
                      borderRadius: "10px",
                      backgroundColor: "#f9f9f9",
                    }}
                  />
                )}

             
                {(() => {
                  const mediaUrl =
                    matchedEntry?.customisations?.[0]?.imageUrl ||
                    matchedEntry?.imageUrl;
                  const isVideo = mediaUrl
                    ? /\.(mp4|webm|avi|mov)$/i.test(mediaUrl)
                    : false;

                  if (!mediaUrl) {
                    return (
                      <Typography variant="body2" color="text.secondary">
                        No media available
                      </Typography>
                    );
                  }

                  return isVideo ? (
                    <CardMedia
                      component="video"
                      src={mediaUrl}
                      controls
                      sx={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  ) : (
                    <CardMedia
                      component="img"
                      image={mediaUrl}
                      alt="Content Image"
                      sx={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  );
                })()}
              </CardContent>
            </Box>
          ) : (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center" }}
            >
              No playlist content available
            </Typography>
          )}
        </Box>

        <DialogActions>
          <Button onClick={() => setShowImage(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {locationsToRender.map((location) => {
        const meetingRooms = meetingSpaces
          .filter((space) => space.locationId === location.id)
          .filter((room) => groupIds?.includes(room?.customProperties?.groups));

        const filteredRooms = actions
          ? meetingRooms.filter((room) => roomIds?.includes(room.id))
          : meetingRooms;

        return (
          <Accordion key={location.id} sx={{ marginBottom: 1 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid container alignItems="center" spacing={2}>
                {!actions && (
                  <Grid item>
                    <Checkbox
                      checked={locationIds?.includes(location.id)}
                      onChange={() => handleLocationCheckboxChange(location.id)}
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs
                  sx={{
                    pt: {
                      xs: 0,
                      md: "unset",
                    },
                  }}
                >
                  <Typography variant="body1">
                    {location.floor}, {location.building}, {location.city}
                  </Typography>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {filteredRooms.map((room) => (
                <Grid
                  item
                  xs={12}
                  key={room.id}
                  sx={{
                    display: "flex",
                    alignItems: {xs:(actions && hasConflicts(room.id))?"start" :"center",md:"center"},
                    flexDirection:  {xs:(actions && hasConflicts(room.id))?"column":"row",md:"row"},
                    margin: ".6rem",
                    gap:{xs:(actions && hasConflicts(room.id))?1:"unset",md:"unset"}
                  }}
                >
                  {!actions && (
                    <Checkbox
                      checked={roomIds.includes(room.id)}
                      onChange={() => handleMeetingRoomCheckboxChange(room.id)}
                    />
                  )}

                  <Typography sx={{ display: "flex", alignItems: "center" }}>
                    {room.name}

                    {hasConflicts(room.id) && (
                      <Box
                        sx={{ ml: 2, display: "flex", alignItems: "center" }}
                      >
                        <WarningIcon
                          sx={{ color: "orange", fontSize: "20px" }}
                        />
                        <Typography
                          variant="caption"
                          sx={{ ml: 1, color: "orange" }}
                        >
                          Conflict detected
                        </Typography>
                      </Box>
                    )}
                  </Typography>

                  {actions && hasConflicts(room.id) && (
                    <Box 
                    sx={{ 
                      marginLeft: {xs:0,md:2 }
                    }}
                    >
                      <Tooltip title="Delete the existing event" arrow>
                        <Button
                          key={room.id}
                          variant="outlined"
                          color="error"
                          onClick={() => handleDeleteRoom(room.id)}
                          sx={{
                            marginRight: 1,
                            padding: "6px 12px",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Delete
                        </Button>
                      </Tooltip>

                      <Tooltip title="Skip meeting creation" arrow>
                        <Button
                          variant="outlined"
                          color="warning"
                          sx={{
                            marginRight: 1,
                            padding: "6px 12px",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                          onClick={() => handleSkipRoom(room.id)}
                        >
                          Skip
                        </Button>
                      </Tooltip>

                      <Tooltip title="Show applied content" arrow>
                        <Button
                          variant="outlined"
                          color="primary"
                          sx={{
                            padding: "6px 12px",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                          onClick={() => handleContentRoom(room.id)}
                        >
                          Content
                        </Button>
                      </Tooltip>
                    </Box>
                  )}
                </Grid>
              ))}
            </AccordionDetails>
          </Accordion>
        );
      })}

      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete all meetings in this room? This
            action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)} color="error">
            Cancel
          </Button>
          <Button onClick={confirmDeleteRoom} color="success">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MyLocationsSmallCard;
